<template>
  <div class="company-search-bar">
    <hf-select
      ref="select"
      v-model="chosen"
      :options="options"
      :placeholder="$t('components.company_search.enter_keyword')"
      :size="size"
      :remote-method="searchForNewsroom"
      :loading="isLoading"
      class="NewsroomSearch__Select"
      value-key="id"
      label-key="name"
      remote
      filterable
      popper-class="NewsroomSearch__Dropdown"
      @change="changeHandler"
    >
      <template #option="{ option: newsroom }">
        <span class="flex items-center gap-2 py-0.5">
          <round-avatar
            :src="newsroom.logo.cropped"
            :main-color="newsroom.main_color"
            size="small"
          />
          <span class="truncate">{{ newsroom.name }}</span>
        </span>
      </template>
    </hf-select>
  </div>
</template>

<script>
import { debounceMixin } from '@/shared/js/mixins/debounceMixin'
import { NewsroomService } from '@/shared/js/services/api/NewsroomService'
import HfSelect from '@/shared/js/components/core/HfSelect.vue'

export default {
  components: { HfSelect },

  mixins: [debounceMixin(['searchForNewsroom']), 250],

  props: {
    size: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      chosen: null,
      options: [],
      isLoading: false
    }
  },

  methods: {
    searchForNewsroom (searchValue) {
      if (searchValue === '') {
        this.options = []
        return
      }
      this.isLoading = true
      NewsroomService.findNewsrooms(searchValue)
        .then(response => {
          this.isLoading = false
          this.options = response
        })
        .catch(error => {
          this.isLoading = false
          this.$displayRequestError(error)
        })
    },
    changeHandler (selected) {
      this.$emit('change', selected)
    },
    focusSelect () {
      this.$nextTick(() => {
        this.$refs.select.focus()
      })
    }
  }
}
</script>
<style scoped lang="scss">
.company-search-bar {
  &__item {
    /*margin-bottom: .5rem;*/
  }
}
</style>
